import React from 'react';
import { Transition } from 'react-transition-group';
import { useRef } from 'react';
import { observer } from 'mobx-react-lite';

const duration = 200;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

export default observer<{in?: boolean}>(function Fade({ in: inProp, children }) {
  const nodeRef = useRef(null);
  return (
    <Transition nodeRef={nodeRef} in={inProp} timeout={duration} unmountOnExit>
      {state => (
        <div ref={nodeRef} style={{
          ...defaultStyle,
          ...transitionStyles[state as keyof typeof transitionStyles]
        }}>
          {children}
        </div>
      )}
    </Transition>
  );
});
